import React from 'react'
import ServiceList from './ServiceList.js'
import { connect } from 'react-redux'
import Grid from '@material-ui/core/Grid'
import { CircularProgress } from '@material-ui/core';

const Services = (props) => {
// console.log('Serivce Component', props)

  return (
    <div style={{padding: '5px', margin: '10px'}}>
      <Grid container>
        <Grid item lg={6} xs={12}>
          <h1>Services</h1>
        </Grid>
        <Grid item lg={6} xs={12}>
        </Grid>
        <Grid item lg={12} xs={12}>
        <ServiceList />
        </Grid>
      </Grid>
      
  </div>
  )
}

  const mapStateToProps = (state) => {
    return {
      url: state.url,
      user: state.user,
      notification: state.notification
    }
  }
  
  export default connect(mapStateToProps)(Services)